"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./age-for-comp-soc"), exports);
__exportStar(require("./allegato"), exports);
__exportStar(require("./allegato-dto"), exports);
__exportStar(require("./big-int-param"), exports);
__exportStar(require("./bind-user-group-roles-dto"), exports);
__exportStar(require("./bind-user-group-roles-delibera-dto"), exports);
__exportStar(require("./bo-registrazione-pagamento-quota-annuale-massivo-body"), exports);
__exportStar(require("./cancellati-reiscritti-entity-view"), exports);
__exportStar(require("./cittadinanza-dto"), exports);
__exportStar(require("./codice-ateco"), exports);
__exportStar(require("./codice-ateco-by-id-dto"), exports);
__exportStar(require("./codice-ateco-dto"), exports);
__exportStar(require("./codifica-stati-dto"), exports);
__exportStar(require("./collaborazione-con-studio-associato-dto"), exports);
__exportStar(require("./composizione-societaria"), exports);
__exportStar(require("./composizione-societaria-dto"), exports);
__exportStar(require("./comune"), exports);
__exportStar(require("./comune-dto"), exports);
__exportStar(require("./csv-elenco-iscritti-filter"), exports);
__exportStar(require("./dispositivo"), exports);
__exportStar(require("./elenco-iscrizioni-by-cf-dto"), exports);
__exportStar(require("./fo-registrazione-pagamento-quota-annuale-massivo-body"), exports);
__exportStar(require("./forma-giuridica"), exports);
__exportStar(require("./forma-giuridica-by-id-dto"), exports);
__exportStar(require("./forma-giuridica-dto"), exports);
__exportStar(require("./generic-request-dto"), exports);
__exportStar(require("./iot-dto"), exports);
__exportStar(require("./iscritti-entity-view"), exports);
__exportStar(require("./iscrizione-attiva-by-tipologia-anagrafe-cf-piva"), exports);
__exportStar(require("./iscrizione-by-cf-resp-stp"), exports);
__exportStar(require("./iscrizione-ordine-territoriale"), exports);
__exportStar(require("./iscrizione-soggetto-entity-view"), exports);
__exportStar(require("./laurea"), exports);
__exportStar(require("./laurea-dto"), exports);
__exportStar(require("./local-date"), exports);
__exportStar(require("./local-date-time"), exports);
__exportStar(require("./model-date"), exports);
__exportStar(require("./motivo-cancellazione"), exports);
__exportStar(require("./ordine-by-sigla-automobilistica-request"), exports);
__exportStar(require("./ordine-competente-by-specific-group-dto"), exports);
__exportStar(require("./paged-cancellati-reiscritti-entity-view"), exports);
__exportStar(require("./paged-iscritti-entity-view"), exports);
__exportStar(require("./paged-request-dto"), exports);
__exportStar(require("./paged-soggetto"), exports);
__exportStar(require("./parameter-input-dto"), exports);
__exportStar(require("./po-assicurazione"), exports);
__exportStar(require("./po-assicurazione-allegati"), exports);
__exportStar(require("./po-assicurazione-aumento-massimale"), exports);
__exportStar(require("./po-compilazione-rischio-dettaglio"), exports);
__exportStar(require("./po-compilazione-tabella-rischio"), exports);
__exportStar(require("./po-fascia-rischio-massimali"), exports);
__exportStar(require("./po-tabelle-fascia-rischio-massimali"), exports);
__exportStar(require("./po-voci-prestazione"), exports);
__exportStar(require("./provincia"), exports);
__exportStar(require("./provincia-dto"), exports);
__exportStar(require("./quota-annuale"), exports);
__exportStar(require("./quota-annuale-dto"), exports);
__exportStar(require("./quota-by-ordine-dto"), exports);
__exportStar(require("./quote-ordini-dto"), exports);
__exportStar(require("./regione"), exports);
__exportStar(require("./registrazione-pagamento-quota-annuale-dto"), exports);
__exportStar(require("./report-by-date"), exports);
__exportStar(require("./report-ini-pec-files"), exports);
__exportStar(require("./responsabile-legale-dto"), exports);
__exportStar(require("./response-dto"), exports);
__exportStar(require("./ricerca-albo-pfdto"), exports);
__exportStar(require("./ricerca-albo-pgdto"), exports);
__exportStar(require("./ricerca-ordine-dto"), exports);
__exportStar(require("./richiesta-integrazioni"), exports);
__exportStar(require("./richiesta-integrazioni-by-id-iscrizione-dto"), exports);
__exportStar(require("./sede-legale"), exports);
__exportStar(require("./sede-legale-dto"), exports);
__exportStar(require("./sezione"), exports);
__exportStar(require("./sezione-by-id-dto"), exports);
__exportStar(require("./sezione-dto"), exports);
__exportStar(require("./sigla-provincia-dto"), exports);
__exportStar(require("./soggetto"), exports);
__exportStar(require("./soggetto-by-cf-anagrafe-tipo-iscrizione-dto"), exports);
__exportStar(require("./soggetto-by-cf-tipo-anagrafe-dto"), exports);
__exportStar(require("./soggetto-by-id-and-tipologia-dto"), exports);
__exportStar(require("./soggetto-by-id-iscrizione"), exports);
__exportStar(require("./soggetto-dto"), exports);
__exportStar(require("./soggetto-hist"), exports);
__exportStar(require("./string-param"), exports);
__exportStar(require("./studio-associato-dto"), exports);
__exportStar(require("./tipo-laurea"), exports);
__exportStar(require("./tipo-laurea-dto"), exports);
__exportStar(require("./tipologia-iscrizione-dto"), exports);
__exportStar(require("./tipologia-pagamento"), exports);
__exportStar(require("./tipologia-societa"), exports);
__exportStar(require("./tipologia-societa-by-id-dto"), exports);
__exportStar(require("./tipologia-societa-dto"), exports);
__exportStar(require("./tipologia-utente-enum"), exports);
__exportStar(require("./titolo"), exports);
__exportStar(require("./titolo-dto"), exports);
__exportStar(require("./upload-item-schema"), exports);
